import { configureStore } from '@reduxjs/toolkit'
import currentComplexReducer from './features/currentComplex/currentComplexSlice'

export default configureStore({
  reducer: {
    currentComplex: currentComplexReducer,
  },
})